module.exports = __webpack_public_path__ + "static/media/provider_mtn.1ac94e7e.png";